import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import PauseShift from './pauseShift';
import RegularShift from './regularShift';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../text/messages';
import { timeObjectToMinutes, timeObjectFromMoment } from '../../../../utilities/time';
import img from '../../../../assets/images/guitar.png';
import { beginsWith, finishesWith, sortByString } from '../../../../utilities/string';

class AddTimeForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addMode: false
        };

        this.renderShifts = this.renderShifts.bind(this);
    }

    UNSAFE_componentWillReceiveProps({ addMode }) {
        this.setState({ addMode });
    }

    renderShifts() {
        const { shifts, removeTime, isMobile, projects, isW2 } = this.props;
        const sortedProjects = sortByString(projects, 'name');
        return (
            <div>
                {shifts.map(
                    (shift, i) =>
                        shift.type === 'pause' ? (
                            isW2 && <PauseShift key={i} shift={shift} />
                        ) : shift.type === 'regular' ? (
                            <RegularShift
                                key={i}
                                index={i}
                                shift={shift}
                                remove={removeTime}
                                isMobile={isMobile}
                                disabled={true}
                                projects={sortedProjects}
                                isW2={isW2}
                            />
                        ) : null
                )}
            </div>
        );
    }

    render() {
        const { shifts, saveTime, toggleAddMode, nextTimeIn, dayIndex, copySessions, hasPrevDayShifts, projects, isW2 } = this.props;

        const { addMode } = this.state;
        const regular = shifts.filter(s => s.type === 'regular');
        const lastRegularMinutes = regular.length ? timeObjectToMinutes(timeObjectFromMoment(regular[regular.length - 1].time_out)) : 0;
        const addTimeMintes = timeObjectToMinutes(nextTimeIn);
        const nexPauseMinutes = regular.length && lastRegularMinutes < addTimeMintes ? addTimeMintes - lastRegularMinutes : 0;

        return (
            <div>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="preview-wrapper">
                            {shifts.length || addMode ? (
                                <div>
                                    {this.renderShifts()}
                                    {addMode && (
                                        <div className="row">
                                            <div className="col-xs-12">
                                                {isW2 && <PauseShift shift={{ minutes: nexPauseMinutes }} />}
                                                <RegularShift index="new" shift={{}} saveTime={saveTime} projects={projects} isW2={isW2} />
                                            </div>
                                        </div>
                                    )}
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <span className="additional-session" onClick={toggleAddMode}>
                                                {addMode ? <FormattedMessage {...messages.cancel} /> : <FormattedMessage {...messages.addAnouterSession} />}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div className="img-wrapper">
                                        <div className="img-box" style={{ backgroundImage: `url(${img})` }} />
                                    </div>
                                    <div className="empty-actions">
                                        <div className="additional-session" onClick={toggleAddMode}>
                                            {addMode ? <FormattedMessage {...messages.cancel} /> : <FormattedMessage {...messages.addNewSession} />}
                                        </div>
                                        {!!dayIndex &&
                                            !!hasPrevDayShifts && (
                                                <div className="copy-shifts" onClick={copySessions}>
                                                    <FormattedMessage {...messages.copySessions} />
                                                </div>
                                            )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

AddTimeForm.propTypes = {
    shifts: PropTypes.array,
    toggleAddMode: PropTypes.func,
    removeTime: PropTypes.func,
    copySessions: PropTypes.func,
    saveTime: PropTypes.func,
    dayTotal: PropTypes.object,
    addMode: PropTypes.bool,
    hasPrevDayShifts: PropTypes.bool
};

const selector = formValueSelector('add-time');

const validate = (values, props) => {
    const { shifts } = props;
    const errors = {};

    const regular = shifts.filter(s => s.type === 'regular');
    Object.keys(values)
        .filter(k => beginsWith(k, 'time_in'))
        .forEach(k => {
            const index = k.split('$')[1];
            const projectId = values[`project_id$${index}`];

            if (!props.isW2) {
                return !!projectId ? {} : { [`time_in$${index}`]: <FormattedMessage id={'addTime.noProject'} defaultMessage={'Project is required'} /> };
            }

            const intIndex = parseInt(index, 10);
            const start = timeObjectToMinutes(values[`time_in$${index}`]);
            const end = timeObjectToMinutes(values[`time_out$${index}`]);

            const isOverlap = regular.some(
                s =>
                    shifts.indexOf(s) !== intIndex &&
                    start < timeObjectToMinutes(timeObjectFromMoment(s.time_out)) &&
                    end > timeObjectToMinutes(timeObjectFromMoment(s.time_in))
            );

            const diff = end - start;
            if (diff <= 15) {
                errors[`time_in$${index}`] = (
                    <FormattedMessage id={'addTime.lessThan15Minutes'} defaultMessage={'Your shift has to be longer than 15 minutes.'} />
                );

                if (diff < 0) {
                    errors[`time_in$${index}`] = (
                        <FormattedMessage id={'addTime.lessThan0Minutes'} defaultMessage={'Start time cannot be later than end time.'} />
                    );
                }
            } else if (isOverlap) {
                errors[`time_in$${index}`] = <FormattedMessage id={'addTime.overLapping'} defaultMessage={'Your shift has some overlap with other shifts.'} />;
            } else if (!projectId) {
                errors[`time_in$${index}`] = <FormattedMessage id={'addTime.noProject'} defaultMessage={'Project is required'} />;
            }
        });

    return errors;
};
AddTimeForm = reduxForm({
    form: 'add-time',
    destroyOnUnmount: false,
    enableReinitialize: true,
    forceUnregisterOnUnmount: true,
    onChange: (values, _, props, old) => {
        const { saveTime, dirty } = props;
        Object.keys(values)
            .filter(k => (beginsWith(k, 'time_') || beginsWith(k, 'project') || beginsWith(k, 'minutes') || beginsWith(k, 'hours')) && !finishesWith(k, 'new'))
            .forEach(k => {
                const newVal = beginsWith(k, 'time_') ? timeObjectToMinutes(values[k]) : values[k];
                const oldVal = beginsWith(k, 'time_') ? timeObjectToMinutes(old[k]) : old[k];

                if (newVal !== oldVal) {
                    const errors = validate(values, props);
                    if (!Object.entries(errors).length && dirty) {
                        saveTime(parseInt(k.split('$')[1], 10));
                    }
                }
            });
    },
    validate
})(AddTimeForm);

const mapStateToProps = state => {
    return {
        nextTimeIn: selector(state, 'time_in$new')
    };
};
AddTimeForm = connect(mapStateToProps)(AddTimeForm);
export default AddTimeForm;



// WEBPACK FOOTER //
// ./src/pages/timekeeping/components/addTime/addTimeForm.jsx